/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "검사 현황" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                    <a-input v-model="pop" placeholder="부품코드" style="margin-right: 10px; width: 200px"/>	
                    <span class = 'icon_button' @click="handlerToCreateCSForFilterPop()">	
                        <a-tag color="#2980B9" style="cursor:pointer;">	
                            <a-icon type="plus-circle" /> 불러오기	
                        </a-tag>	
                    </span>
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <a-space align="end">
            <!-- <a-statistic title="작성필요" :value="data.length" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="check-circle" />
                </template>
            </a-statistic> -->
            <a-statistic title="검사중" :value="pagination1.total" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="question-circle" />
                </template>
            </a-statistic>
             <a-statistic title="검사완료" :value="pagination2.total" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="exclamation-circle" />
                </template>
            </a-statistic>
            <a-radio-group style = ''>
                <!-- <a-radio-button value="작성필요">작성필요 보기</a-radio-button> -->
                <!-- <a-radio-button value="검사중">검사중 보기</a-radio-button> -->
                <!-- <a-radio-button value="검사완료">검사완료 보기</a-radio-button>
                <a-radio-button value="모두">모두보기</a-radio-button> -->
            </a-radio-group>
        </a-space>
        <p/>
        <a-progress type = 'line' :percent="90" strokeColor = '#C7C6C6'/>
        <p/>
        <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="pagination1" :scroll="{ x: 0, y: '30vh' }" @change="handleTable1Change">
            <span slot="tags" slot-scope="tags">
                <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '검사중'), green: (tag === '검사완료') }">
                    {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="name" slot-scope="text">{{ text }}</span>
            <span slot="pop" slot-scope="pop">{{ pop }}</span>
            <span slot="updated" slot-scope="updated">{{ updated }}</span>
            <span slot="action" slot-scope="record">
                <!-- <span style = 'cursor:pointer' @click="handlerToConfirmProductCS(record.key, 'C')"><a-icon type="check-circle" /> Confirm</span>	
                <a-divider type="vertical" /> -->	
                <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'O')"><a-icon type="edit" /> Edit</span>	
                <a-divider type="vertical" />	
                <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'O')"><a-icon type="delete" /> Delete</span>
            </span>
        </a-table>
        <p/>
        <a-form class="" layout = "vertical" >
            <!-- <a-card>
                <a-form-item label="점검시트 작성 일자설정">
                    <a-space align="end">
                        <a-date-picker />
                        <a-radio-group style = ''>
                            <a-radio-button value="작성필요">작성필요 보기</a-radio-button>
                            <a-radio-button value="검사중">검사중 보기</a-radio-button>
                            <a-radio-button value="검사완료">검사완료 보기</a-radio-button>
                            <a-radio-button value="모두">모두보기</a-radio-button>
                        </a-radio-group>
                    </a-space>
                </a-form-item>
                <p/>
                <a-table :columns="columns2" size = "small" :bordered=false :data-source="data" :pagination="false" :scroll="{ x: 0, y: '57vh' }">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" >
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="">
                        <a-checkbox @change="onChange">
                            선택
                        </a-checkbox>
                    </span>
                </a-table>
            </a-card>
            <p/> -->
            <a-card>
                <a-space align="end">
                    일자 조회
                    <date-picker v-model="filterDateStartCS" valueType="format" @change="filterCSList" style="width:120px;"></date-picker> ~
                    <date-picker v-model="filterDateEndCS" valueType="format" @change="filterCSList" style="width:120px;"></date-picker>
                </a-space>
                <p/>
                <a-table :columns="columns3" size = "small" :bordered=false :data-source="data3" :pagination="pagination2" :scroll="{ x: 0, y: '57vh' }" @change="handleTable2Change">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '검사중'), green: (tag === '검사완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="record">
                        <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'P')"><a-icon type="edit" /> Edit</span>	
                        <a-divider type="vertical" />	
                        <!-- <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'D')"><a-icon type="delete" /> Delete</span> -->
                    </span>
                </a-table>
            </a-card>

        </a-form>
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="100%" >
            <FilterViewer :target = "target" :pop = "pop" :showSaveBtn = true :showConfirmBtn = true v-on:flagForDrawer="handlerForCloseDrawer" v-on:editFilterCS="handlerToEditFilterCS" />
        </a-drawer>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";
import FilterViewer from "./FilterViewer.vue" ;

const userAgent = navigator.userAgent.toLowerCase();
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|samsungbrowser|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

let columns = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 100},
    {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 150},
    {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
    {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 100},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 180},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 200},
];
if (isTablet) {
    columns = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        }, width : 100},
        {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 80},
        {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 80},
        {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
        {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 50},
        {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 80},
        {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },},
    ];
}

const columns2 = [
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 100},	
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},	
    {    title: '이름'    ,   dataIndex: 'name' ,   key: 'name'     ,  scopedSlots: { customRender: 'name'        },},
];
let columns3 = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 100},
    {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 150},
    {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 100},
    {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 100},
    {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 80},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 180},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 80},
];
if (isTablet) {
    columns3 = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
        {    title: '검사대상' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 80},
        {    title: '부품코드' , dataIndex: 'partCode' , key: 'partCode' , scopedSlots: { customRender: 'partCode' }, width : 80},
        {    title: '부품품명' , dataIndex: 'partName' , key: 'partName' , scopedSlots: { customRender: 'partName' },},
        {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 50},
        {    title: 'LOT' , dataIndex: 'barcode' , key: 'barcode' , scopedSlots: { customRender: 'barcode' }, width : 80},
        {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 50},
        {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },},
    ];
}

const data = [
  {    key: '1',    name: 'FGCS210505-WP400-V1 보류중 20200401-15:30'   ,  tags: ['필요'],  },
  {    key: '2',    name: 'FGCS210505-WP301-V1 보류중 20200329-09:30'   ,  tags: ['필요'],  },
  {    key: '3',    name: 'PCCS210505-WP400-V1 완료 20200401-15:30'     ,  tags: ['진행'],  },
  {    key: '4',    name: 'PCCS210505-WP301-V1 완료 20200329-09:30'     ,  tags: ['완료'],  },
];
const data3 = [
  {    key: '1',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },
  {    key: '2',    name: '정수기', model: 'WP-400',cs : 'FGCS210505-WP400-V1 ',id: '홍길동',created:'2021-01-01',updated:'2021-01-01' ,  tags: ['완료'],  },

];
export default {
    name: 'SheetFilter',
    components: {
        PageHeader ,
        DatePicker, 
        FilterViewer,
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            data,
            columns,
            columns2,
            columns3,
            data3,
            data3Backup: [],
            dataArray: [],	
            dataArray3: [],	
            pop: null,	
            target: null,	
            filterCS : '',	
            filterField: '모델명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination1: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            pagination2: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            }
        };
    },
    mounted() {
        this.pop = sessionStorage.getItem('filter_pop') || '';
        
        this.isDataLoaded = true;
        this.fetchProductCSList();

        if (isTablet) {
            let x;
            let els1 = document.body.querySelectorAll('.ant-layout-header');
            for (x = 0; x < els1.length; x++) {
                els1[x].style.display = 'none';
            }
            let els2 = document.body.querySelectorAll('.ant-breadcrumb');
            for (x = 0; x < els2.length; x++) {
                els2[x].style.display = 'none';
            }
            let els3 = document.body.querySelectorAll('.ant-divider-horizontal');
            for (x = 0; x < els3.length; x++) {
                els3[x].style.display = 'none';
            }
            let els4 = document.body.querySelectorAll('.desktop-only');
            for (x = 0; x < els4.length; x++) {
                els4[x].style.display = 'none';
            }
            let els5 = document.body.querySelectorAll('.ant-layout-sider');
            for (x = 0; x < els5.length; x++) {
                els5[x].style.display = 'none';
            }
        }
    },
    methods : {
        // showDrawer() {
        //     this.flagForDrawer = true;
        // },
        // closeDrawer() {
        //     this.flagForDrawer = false;
        // },
        // editTool() {
        //     console.log("## editTool in Tools ##");
        //     this.flagForDrawer = true;
        // },
        // deleteTool() {
        //     console.log("## deleteTool in Tools  ##");
        //     this.flagForDrawer = true;
        // }
        fetchProductCSList(skipBarcodeScan, forceView) {
            this.dataArray = [];
            this.data = [];
            this.data3 = [];
            
            // 두 개의 API 호출을 병렬로 처리
            this.fetchStateOData(skipBarcodeScan, forceView);
            this.fetchStatePData();
        },
        
        fetchStateOData(skipBarcodeScan, forceView, page = 1, pageSize = 10) {
            // 검사중(state=O) 데이터 조회
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_simple?size=${pageSize}&page=${page - 1}&state=O`;
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    this.dataArray = response.data.data.content;
                    
                    // Update pagination info
                    this.pagination1.total = response.data.data.totalElements || 0;
                    this.pagination1.current = page;
                    this.pagination1.pageSize = pageSize;
                    
                    // 정렬
                    this.dataArray = _.orderBy(this.dataArray, ['updated'], ['desc']);

                    // Process array data
                    this.processStateOData();
                    
                    // 바코드 스캔 또는 타겟 설정
                    if (skipBarcodeScan && forceView) {
                        this.handleScannedBarcode();
                    } else if (this.pop) {
                        this.handlePop();
                    }
                }
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        fetchStatePData(page = 1, pageSize = 10) {
            // 검사완료(state=P) 데이터 조회
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_simple?size=${pageSize}&page=${page - 1}&state=P`;
            
            if (this.filterDateStartCS || this.filterDateEndCS) {
                if (this.filterDateStartCS) {
                    urlToFetchProductCSList += `&start_date=${this.filterDateStartCS}`;
                }
                if (this.filterDateEndCS) {
                    // end_date에는 23:59:59 추가
                    urlToFetchProductCSList += `&end_date=${this.filterDateEndCS} 23:59:59`;
                }
            }
            
            if (this.filterCS) {
                if (this.filterField === '모델명') {
                    urlToFetchProductCSList += `&model=${this.filterCS}`;
                } else if (this.filterField === '제품명') {
                    urlToFetchProductCSList += `&product=${this.filterCS}`;
                } else if (this.filterField === '검사결과') {
                    urlToFetchProductCSList += `&checkState=${this.filterCS.toUpperCase()}`;
                }
            }
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    this.dataArray3 = response.data.data.content;
                    
                    // Update pagination info
                    this.pagination2.total = response.data.data.totalElements || 0;
                    this.pagination2.current = page;
                    this.pagination2.pageSize = pageSize;
                    
                    // 정렬
                    this.dataArray3 = _.orderBy(this.dataArray3, ['updated'], ['desc']);

                    // Process array data
                    this.processStatePData();
                }
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        processStateOData() {
            // 기존 데이터 처리 로직
            _.forEach(this.dataArray, function(item) {
                _.forEach(item.listProductCSInpection, function(item2) {
                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                            ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            obj.ngTitle = ngTitle[j];
                            obj.ngContent = ngContent[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                });
            });
            
            this.data = [];
            for(let x = 0; x < this.dataArray.length ; x ++) {
                let tags = ['검사중'];

                // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                let updatedObj = new Date((new Date(this.dataArray[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                let hour = updatedObj.getHours().toString().padStart(2, '0');
                let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                let second = updatedObj.getSeconds().toString().padStart(2, '0');

                this.data.push({
                    key : x,
                    name : this.dataArray[x].name,
                    pop : this.dataArray[x].partCode,
                    tags : tags,
                    updated : `${year}-${month}-${date} ${hour}:${minute}:${second}`,
                    model : this.dataArray[x].clsProduct.productModel,
                    modelDetail : this.dataArray[x].clsProduct.productModelDetail,
                    product : this.dataArray[x].clsProduct.productName,
                    line : this.dataArray[x].line,
                    barcode : this.dataArray[x].barcode,
                    manager : this.dataArray[x].manager,
                    category : this.dataArray[x].category,
                    partName : this.dataArray[x].partName,
                    partCode : this.dataArray[x].partCode,
                    image1 : this.dataArray[x].image1,
                    image2 : this.dataArray[x].image2,
                    productCsSeq: this.dataArray[x].productCsSeq
                });
            }
        },
        
        processStatePData() {
            // 기존 데이터 처리 로직
            _.forEach(this.dataArray3, function(item) {
                _.forEach(item.listProductCSInpection, function(item2) {
                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                            ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            obj.ngTitle = ngTitle[j];
                            obj.ngContent = ngContent[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                });
            });
            
            this.data3 = [];
            for(let x = 0; x < this.dataArray3.length ; x ++) {
                let tags = ['검사완료'];

                // TO DO - 서버에서 수정한 후 이 코드 삭제 - updated 가 9 시간이 작게 나와서 프론트엔드에서 수정
                let updatedObj = new Date((new Date(this.dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                let hour = updatedObj.getHours().toString().padStart(2, '0');
                let minute = updatedObj.getMinutes().toString().padStart(2, '0');
                let second = updatedObj.getSeconds().toString().padStart(2, '0');

                let checkState = 'PASS';
                // _.forEach(this.dataArray3[x].listProductCSInpection, function(item) {
                //     _.forEach(item.listProductCSInpectionStandard, function(item2) {
                //         if (item2.min === 'NG') {
                //             checkState = 'NG';
                //         }
                //     });
                // });
                if (this.dataArray3[x].csTime === 'FAIL') {
                    checkState = 'FAIL';
                }

                this.data3.push({
                    key : x,
                    name : this.dataArray3[x].name,
                    pop : this.dataArray3[x].partCode,
                    tags : tags,
                    updated : `${year}-${month}-${date} ${hour}:${minute}:${second}`,
                    model : this.dataArray3[x].clsProduct.productModel,
                    modelDetail : this.dataArray3[x].clsProduct.productModelDetail,
                    product : this.dataArray3[x].clsProduct.productName,
                    line : this.dataArray3[x].line,
                    barcode : this.dataArray3[x].barcode,
                    manager : this.dataArray3[x].manager,
                    checkState: checkState,
                    category : this.dataArray3[x].category,
                    partName : this.dataArray3[x].partName,
                    partCode : this.dataArray3[x].partCode,
                    image1 : this.dataArray3[x].image1,
                    image2 : this.dataArray3[x].image2,
                    productCsSeq: this.dataArray3[x].productCsSeq
                });
            }
            
            this.data3Backup = JSON.parse(JSON.stringify(this.data3));
        },
        
        handleScannedBarcode() {
            // 바코드 스캔 또는 직접 입력 후 체크시트가 생성된 후의 조회인 경우, 수정, 삭제인 경우
            if (this.dataArray.length > 0) {
                let target = this.dataArray[0];  // 방금 생성하였으므로 맨 처음 체크시트 조회 - 기존에는 맨 끝을 찾았으나 this.dataArray 정렬 순서 변경으로 맨 처음을 찾음
                
                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_filter_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];

                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                                    ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    obj.ngTitle = ngTitle[j];
                                    obj.ngContent = ngContent[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })

                        this.target = item;
                        this.flagForDrawer = true;
                    }
                });
            }
        },
        
        handlePop() {
            // 바코드 스캔한 경우
            if (this.pop) {
                let popMatch = false;
                let matchedCS = null;
                let csItem = sessionStorage.getItem('filter_pop_item');
                if (csItem) {
                    csItem = JSON.parse(csItem);
                    matchedCS = csItem;

                    if (csItem.partCode == this.pop) {
                        popMatch = true;
                    }
                }

                // 바코드 매칭이 된 경우
                if (popMatch) {
                    if (confirm(this.pop + ' 체크시트를 작성하시겠습니까?')) {
                        // matchedCS 를 복사해서 valid 값을 C 로 하여 체크시트 생성 후 열기
                        this.handlerToCreateCSForFilter(matchedCS);
                    } else {
                        this.pop = '';
                        sessionStorage.removeItem('filter_pop');
                        sessionStorage.removeItem('filter_pop_item');
                        location.reload();
                    }
                }
            }
        },
        handlerToConfirmProductCS(dataOffset) {
            if (confirm('완료처리하시겠습니까?')) {
                this.data3.push({
                    key: this.dataArray[dataOffset].x,
                    name: this.dataArray[dataOffset].clsProduct.productName,
                    model: this.dataArray[dataOffset].clsProduct.productModel,
                    cs : this.dataArray[dataOffset].name,
                    id: '',
                    created: this.dataArray[dataOffset].created,
                    updated: this.dataArray[dataOffset].updated,
                    tags: ['완료']
                });

                this.data.splice(dataOffset, 1);
            }
        },
        handlerToViewProductCS(dataOffset, state) {
            this.dataOffset = dataOffset;
            let target;
            if (state === 'O') {
                target = this.dataArray[dataOffset];
            } else if (state === 'P') {
                target = this.dataArray3[dataOffset];
            }

            // localStorage 에 저장 여부 확인
            let savedData = localStorage.getItem('cs_item_seq_' + target.productCsSeq);
            if (savedData) {
                this.target = JSON.parse(savedData);
                this.flagForDrawer = true;
            }
            // localStorage 에 없는 경우 API 호출
            else {
                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_filter_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                    .then((response) => {
                        if(response.status === 200 && response.data.code === 'success') {
                            let item = response.data.data.content[0];

                            _.forEach(item.listProductCSInpection, function(item2) {
                                if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                    for (var i = 0; i < 14; i++) {
                                        item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                    }
                                } else if (item2.listProductCSInpectionStandard.length === 1) {
                                    let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                        max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                        name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                        result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                        ngTitle = item2.listProductCSInpectionStandard[0].ngTitle ? item2.listProductCSInpectionStandard[0].ngTitle.split('||') : '||||||||||||||||||||||||||||',
                                        ngContent = item2.listProductCSInpectionStandard[0].ngContent ? item2.listProductCSInpectionStandard[0].ngContent.split('||') : '||||||||||||||||||||||||||||',
                                        obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                    for (var j = 0; j < 15; j++) {
                                        obj.min = min[j];
                                        obj.max = max[j];
                                        obj.name = name[j];
                                        obj.result = result[j];
                                        obj.ngTitle = ngTitle[j];
                                        obj.ngContent = ngContent[j];
                                        item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                    }
                                }
                            })

                            this.target = item;
                            this.flagForDrawer = true;
                        }
                    });
            }
        },
        handlerToEditFilterCS(listItem, state) {
            if (!listItem.line) {
                this.$message.error("라인을 선택해주십시오");
                this.flagForDrawer = true;
                return;
            }

            this.flagForDrawer = false;

            let generatedObjectToPersist = {
                productCsSeq: listItem.productCsSeq,
                productSeq: listItem.clsProduct.productSeq,
                productCSName: listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: state,
                pop: listItem.partCode,
                csTime: listItem.csTime,
                line: listItem.line,
                barcode: listItem.barcode,
                manager: listItem.manager,
            };

            let isNG = false;

            _.forEach(listItem.listProductCSInpection, (item) => {
                let min = [],
                    max = [],
                    name = [],
                    result = [],
                    ngTitle = [],
                    ngContent = [];

                _.forEach(item.listProductCSInpectionStandard, function(item2) {
                    min.push(item2.min || '');
                    max.push(item2.max || '');
                    name.push(item2.name || '');
                    result.push(item2.result || '');
                    ngTitle.push(item2.ngTitle || '');
                    ngContent.push(item2.ngContent || '');
                });

                min = min.join('||');
                max = max.join('||');
                name = name.join('||');
                result = result.join('||');
                ngTitle = ngTitle.join('||');
                ngContent = ngContent.join('||');

                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: min,
                        max: max,
                        name: name,
                        result: result,
                        ngTitle: ngTitle,
                        ngContent: ngContent
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: item.inspectionImage2Seq,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);

                if (max.match('FAIL')) {
                    isNG = true;
                }
            });

            if (isNG) {
                generatedObjectToPersist.csTime = 'FAIL';
            } else {
                generatedObjectToPersist.csTime = '';
            }

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/edit';
            this.$http.put(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('저장되었습니다');
                    // this.fetchProductCSList(true);

                    // localStorage 에 저장된 데이터 삭제
                    localStorage.removeItem('cs_item_seq_' + listItem.productCsSeq);

                    location.reload();
                }  else {
                    this.$message.error('저장되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('저장되지 않았습니다(2).');
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToDeleteProductCS(dataOffset, state) {
            if (state === 'O') {
                this.target = this.dataArray[dataOffset];
            } else if (state === 'P') {
                this.target = this.dataArray3[dataOffset];
            }

            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = this.target;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            this.fetchProductCSList(true);
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        handlerToCreateCSForFilterPop() {
            if (!this.pop) {
                this.$message.error('POP를 입력해주세요');
                return;
            }
            
            let pop = '' + this.pop;    // SAP 는 숫자만 입력되어 length 체크가 안되므로 문자열로 변환
            if (pop) {
                sessionStorage.setItem('filter_pop', pop);

                let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_filter_cs";

                // POP 는 5자리, SAP 는 6자리
                urlToFetchProductCSList += "?partCode=" + pop;

                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        if (!response.data.data.content.length) {
                            this.$message.error('입력하신 부품코드의 검사성적서가 등록되어 있지 않습니다.');
                            return;
                        }
                        
                        let item = response.data.data.content[0];
                        sessionStorage.setItem('filter_pop_item', JSON.stringify(item));

                        location.reload();
                    }
                });
            } else {
                this.$message.error('입력하신 부품코드의 검사성적서가 등록되어 있지 않습니다.');
            }
        },
        handlerToCreateCSForFilter(listItem) {
            let productCSName = 'FTCS' + this.$moment(new Date()).format('YYYYMMDD') + '-' + parseInt(Math.random() * 1000000, 10);

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: productCSName,
                productCSInspections: [],
                productCSTimes: [],
                state: 'O',
                pop: this.pop,
                csTime: ''
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });

            let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
            this.$http.post(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    // CS 생성 성공 - save_filter_data 완료 후 목록 새로고침
                    return this.$http.post(this.$store.state.nodeApiUrl + '/product/cs/save_filter_data', {
                        category: listItem.category,
                        part_name: listItem.partName,
                        part_code: listItem.partCode,
                        image1: listItem.image1,
                        image2: listItem.image2,
                        productCsName: productCSName,
                    });
                } else {
                    return Promise.reject('생성되지 않았습니다(1).');
                }
            })
            .then(() => {
                // save_filter_data 완료 후 목록 새로고침
                this.$message.success('생성되었습니다');
                this.fetchProductCSList(true, true);
                this.pop = '';
                sessionStorage.removeItem('filter_pop');
                sessionStorage.removeItem('filter_pop_item');
            })
            .catch(error => {
                console.error(error);
                this.$message.error(typeof error === 'string' ? error : '생성되지 않았습니다(2).');
            });
        },
        filterCSList() {
            // 검사완료(state=P) 데이터를 새로 조회
            this.fetchStatePData(1, this.pagination2.pageSize);
        },
        
        handleTable1Change(pagination) {
            // 검사중(state=O) 테이블의 페이지 변경 시
            this.fetchStateOData(false, false, pagination.current, pagination.pageSize);
        },
        
        handleTable2Change(pagination) {
            // 검사완료(state=P) 테이블의 페이지 변경 시
            this.fetchStatePData(pagination.current, pagination.pageSize);
        }
    }
}
</script>
<style scoped>
</style>